export default __webpack_public_path__ + "static/media/Group 5174.a936d5ab.svg";